/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BasketsValidatePost200ResponseCoupon model module.
 * @module model/BasketsValidatePost200ResponseCoupon
 * @version 1.0.0
 */
class BasketsValidatePost200ResponseCoupon {
    /**
     * Constructs a new <code>BasketsValidatePost200ResponseCoupon</code>.
     * Coupon resolved from the validated promo code.
     * @alias module:model/BasketsValidatePost200ResponseCoupon
     */
    constructor() { 
        
        BasketsValidatePost200ResponseCoupon.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsValidatePost200ResponseCoupon</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsValidatePost200ResponseCoupon} obj Optional instance to populate.
     * @return {module:model/BasketsValidatePost200ResponseCoupon} The populated <code>BasketsValidatePost200ResponseCoupon</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsValidatePost200ResponseCoupon();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
            if (data.hasOwnProperty('redeem_by')) {
                obj['redeem_by'] = ApiClient.convertToType(data['redeem_by'], 'Date');
            }
            if (data.hasOwnProperty('max_redemptions')) {
                obj['max_redemptions'] = ApiClient.convertToType(data['max_redemptions'], 'Number');
            }
            if (data.hasOwnProperty('times_redeemed')) {
                obj['times_redeemed'] = ApiClient.convertToType(data['times_redeemed'], 'Number');
            }
            if (data.hasOwnProperty('applies_to_products')) {
                obj['applies_to_products'] = ApiClient.convertToType(data['applies_to_products'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsValidatePost200ResponseCoupon</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsValidatePost200ResponseCoupon</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['applies_to_products'])) {
            throw new Error("Expected the field `applies_to_products` to be an array in the JSON data but got " + data['applies_to_products']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
BasketsValidatePost200ResponseCoupon.prototype['id'] = undefined;

/**
 * @member {String} name
 */
BasketsValidatePost200ResponseCoupon.prototype['name'] = undefined;

/**
 * @member {Boolean} valid
 */
BasketsValidatePost200ResponseCoupon.prototype['valid'] = undefined;

/**
 * @member {Date} redeem_by
 */
BasketsValidatePost200ResponseCoupon.prototype['redeem_by'] = undefined;

/**
 * @member {Number} max_redemptions
 */
BasketsValidatePost200ResponseCoupon.prototype['max_redemptions'] = undefined;

/**
 * @member {Number} times_redeemed
 */
BasketsValidatePost200ResponseCoupon.prototype['times_redeemed'] = undefined;

/**
 * @member {Array.<String>} applies_to_products
 */
BasketsValidatePost200ResponseCoupon.prototype['applies_to_products'] = undefined;






export default BasketsValidatePost200ResponseCoupon;

